import { render, staticRenderFns } from "./TableRowNumVialsMixedPerTech.vue?vue&type=template&id=a6b0e0b6&lang=pug&"
import script from "./TableRowNumVialsMixedPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumVialsMixedPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b0e0b6')) {
      api.createRecord('a6b0e0b6', component.options)
    } else {
      api.reload('a6b0e0b6', component.options)
    }
    module.hot.accept("./TableRowNumVialsMixedPerTech.vue?vue&type=template&id=a6b0e0b6&lang=pug&", function () {
      api.rerender('a6b0e0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowNumVialsMixedPerTech.vue"
export default component.exports